module.exports = __webpack_public_path__ + "img/FR.8b296b78.svg";